module.exports = __webpack_public_path__ + "static/media/PlaceholderImage.1117a6db.svg";